import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { deletePromo } from "../../../redux/actions/promos.actions";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";
import { clearError } from "../../../redux/reducers/promos.reducer";

const DeletePromoModal: React.FC<ModalProps> = ({open, setOpen, object}) => {
    const promo = object;

    const handleClose = () => {
      handleReset();
      setOpen(false);
    };

    const handleReset = () => {
      dispatch(clearError());
      setSubmitted(false);
    };

    const dispatch = useDispatch<AppDispatch>();
    const { accessToken } = useSelector((state: RootState) => state.user);
    const { error, loading } = useSelector((state: RootState) => state.promos);

    const [submitted, setSubmitted] = useState(false);

    const handleDelete = async (e: React.FormEvent) => {
      e.preventDefault();
      setSubmitted(true);
      await dispatch(deletePromo(promo?.id));
    };

  const confirming = !submitted;
  const deleting = !confirming && loading && !error;
  const failed = !confirming && !deleting && Boolean(error);

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={deleting}
      tone={confirming ? "warning" : deleting ? undefined : failed ? "error" : "success"}
      title={confirming ? `Delete "${promo?.title}"?` : deleting ? "Deleting…" : failed ? "An error occurred" : "Promo deleted"}
      actions={deleting ? undefined : confirming ?
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleDelete} disabled={!accessToken}>Delete</button>
        </>
        : failed ?
        <>
          <button className="btn" onClick={handleClose}>Close</button>
          <button className="btn btn-primary" onClick={handleReset}>Try again</button>
        </>
        :
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
      }
    >
      {confirming ?
        <p>This action cannot be undone.</p>
        : deleting ?
        <ModalLoading/>
        : failed ?
        <p>{error}</p>
        :
        <p>Promo successfully deleted.</p>
      }
    </ModalShell>
  );
};

export default DeletePromoModal;
